(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-timer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const minuteValue = (value) => {
      const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(value || '');

      if (!match) {
        return null;
      }

      return Number(match[1]) * 60 + Number(match[2]);
    };

    const parsedTime = (value) => {
      const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(value || '');

      if (!match) {
        return null;
      }

      return {
        hour: Number(match[1]),
        minute: Number(match[2])
      };
    };

    const zonedParts = (timeZone, date = new Date()) => {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone,
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      return formatter.formatToParts(date).reduce((parts, part) => {
        parts[part.type] = part.value;
        return parts;
      }, {});
    };

    const timeZoneOffset = (timeZone, date) => {
      const parts = zonedParts(timeZone, date);
      const asUtc = Date.UTC(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day),
        Number(parts.hour) % 24,
        Number(parts.minute),
        Number(parts.second)
      );

      return asUtc - date.getTime();
    };

    const zonedDateToInstant = (dateKey, time, timeZone) => {
      const dateParts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey || '');

      if (!dateParts || !time) {
        return null;
      }

      const utcGuess = Date.UTC(
        Number(dateParts[1]),
        Number(dateParts[2]) - 1,
        Number(dateParts[3]),
        time.hour,
        time.minute,
        0
      );
      const firstOffset = timeZoneOffset(timeZone, new Date(utcGuess));
      const secondOffset = timeZoneOffset(timeZone, new Date(utcGuess - firstOffset));

      return new Date(utcGuess - secondOffset);
    };

    const addDays = (dateKey, days) => {
      const dateParts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey || '');

      if (!dateParts) {
        return dateKey;
      }

      const date = new Date(Date.UTC(Number(dateParts[1]), Number(dateParts[2]) - 1, Number(dateParts[3]) + days));
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    };

    const timerPart = (value, label) => `${value} ${label}${value === 1 ? '' : 's'}`;

    const formatTimer = (milliseconds) => {
      const totalMinutes = Math.max(0, Math.ceil(milliseconds / 60000));
      const days = Math.floor(totalMinutes / 1440);
      const hours = Math.floor(totalMinutes % 1440 / 60);
      const minutes = totalMinutes % 60;
      const parts = [];

      if (days > 0) {
        parts.push(timerPart(days, 'day'));
      }

      if (hours > 0 || days > 0) {
        parts.push(timerPart(hours, 'hour'));
      }

      parts.push(timerPart(minutes, 'minute'));

      return parts.join(' ');
    };

    const dayIndexes = {
      Sun: 0,
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6
    };

    const getTimeZone = (bar) => {
      try {
        zonedParts(bar.dataset.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone);
        return bar.dataset.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (error) {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
    };

    const scheduleState = (bar) => {
      const timeZone = getTimeZone(bar);
      const parts = zonedParts(timeZone);
      const dateKey = `${parts.year}-${parts.month}-${parts.day}`;
      const startDate = bar.dataset.startDate;
      const endDate = bar.dataset.endDate;
      const days = (bar.dataset.visibleDays || '')
        .split(',')
        .filter(Boolean)
        .map((day) => Number(day));
      const currentDay = dayIndexes[parts.weekday];
      const previousDay = currentDay === 0 ? 6 : currentDay - 1;
      const currentMinute = Number(parts.hour) % 24 * 60 + Number(parts.minute);
      const startMinute = minuteValue(bar.dataset.startTime);
      const endMinute = minuteValue(bar.dataset.endTime);
      const startTime = parsedTime(bar.dataset.startTime);
      const endTime = parsedTime(bar.dataset.endTime);

      if (startMinute === null || endMinute === null || !startTime || !endTime) {
        return {
          active: false,
          target: null
        };
      }

      const rangeStart = startDate ? zonedDateToInstant(startDate, startTime, timeZone) : null;
      const rangeEnd = endDate ? zonedDateToInstant(endDate, endTime, timeZone) : null;

      if (bar.dataset.scheduleEnabled === 'true') {
        if (rangeEnd) {
          const now = new Date();

          if (rangeStart && now < rangeStart) {
            return {
              active: false,
              target: rangeEnd
            };
          }

          return {
            active: now < rangeEnd,
            target: rangeEnd
          };
        }

        if (startDate && dateKey < startDate) {
          return {
            active: false,
            target: null
          };
        }

        if (endDate && dateKey > endDate) {
          return {
            active: false,
            target: null
          };
        }

        if (!days.length) {
          return {
            active: false,
            target: null
          };
        }

        if (startMinute === endMinute) {
          return {
            active: days.includes(currentDay),
            target: zonedDateToInstant(addDays(dateKey, 1), endTime, timeZone)
          };
        }

        if (startMinute < endMinute) {
          return {
            active: days.includes(currentDay) && currentMinute >= startMinute && currentMinute < endMinute,
            target: zonedDateToInstant(dateKey, endTime, timeZone)
          };
        }

        if (days.includes(currentDay) && currentMinute >= startMinute) {
          return {
            active: true,
            target: zonedDateToInstant(addDays(dateKey, 1), endTime, timeZone)
          };
        }

        return {
          active: days.includes(previousDay) && currentMinute < endMinute,
          target: zonedDateToInstant(dateKey, endTime, timeZone)
        };
      }

      if (rangeEnd) {
        return {
          active: new Date() < rangeEnd,
          target: rangeEnd
        };
      }

      if (startMinute > endMinute && currentMinute >= startMinute) {
        return {
          active: true,
          target: zonedDateToInstant(addDays(dateKey, 1), endTime, timeZone)
        };
      }

      if (currentMinute >= endMinute) {
        return {
          active: true,
          target: zonedDateToInstant(addDays(dateKey, 1), endTime, timeZone)
        };
      }

      return {
        active: true,
        target: zonedDateToInstant(dateKey, endTime, timeZone)
      };
    };

    const updateBars = (container = document) => {
      container.querySelectorAll('[data-shedule-bar-timer]').forEach((bar) => {
        const state = scheduleState(bar);
        const isDesignMode = window.Shopify && window.Shopify.designMode;
        const isVisible = isDesignMode || state.active;
        const timer = bar.querySelector('[data-shedule-bar-timer-clock]');
        const timerValue = bar.querySelector('[data-shedule-bar-timer-value]');

        bar.hidden = !isVisible;

        if (!timer || !timerValue || bar.dataset.timerEnabled !== 'true') {
          return;
        }

        if (!state.target) {
          timer.hidden = true;
          return;
        }

        timer.hidden = false;
        timerValue.textContent = formatTimer(state.target.getTime() - Date.now());

        if (state.target.getTime() <= Date.now() && !isDesignMode) {
          bar.hidden = true;
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => updateBars());
    document.addEventListener('shopify:section:load', (event) => updateBars(event.target));

    updateBars();
    window.setInterval(updateBars, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-announcement-timer"]) return;
  try {
    
  (() => {
    const minuteValue = (value) => {
      const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(value || '');

      if (!match) {
        return null;
      }

      return Number(match[1]) * 60 + Number(match[2]);
    };

    const parsedTime = (value) => {
      const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(value || '');

      if (!match) {
        return null;
      }

      return {
        hour: Number(match[1]),
        minute: Number(match[2])
      };
    };

    const zonedParts = (timeZone, date = new Date()) => {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone,
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      return formatter.formatToParts(date).reduce((parts, part) => {
        parts[part.type] = part.value;
        return parts;
      }, {});
    };

    const timeZoneOffset = (timeZone, date) => {
      const parts = zonedParts(timeZone, date);
      const asUtc = Date.UTC(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day),
        Number(parts.hour) % 24,
        Number(parts.minute),
        Number(parts.second)
      );

      return asUtc - date.getTime();
    };

    const zonedDateToInstant = (dateKey, time, timeZone) => {
      const dateParts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey || '');

      if (!dateParts || !time) {
        return null;
      }

      const utcGuess = Date.UTC(
        Number(dateParts[1]),
        Number(dateParts[2]) - 1,
        Number(dateParts[3]),
        time.hour,
        time.minute,
        0
      );
      const firstOffset = timeZoneOffset(timeZone, new Date(utcGuess));
      const secondOffset = timeZoneOffset(timeZone, new Date(utcGuess - firstOffset));

      return new Date(utcGuess - secondOffset);
    };

    const addDays = (dateKey, days) => {
      const dateParts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey || '');

      if (!dateParts) {
        return dateKey;
      }

      const date = new Date(Date.UTC(Number(dateParts[1]), Number(dateParts[2]) - 1, Number(dateParts[3]) + days));
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    };

    const formatTimer = (milliseconds) => {
      const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
      const minutes = String(Math.floor(totalSeconds % 3600 / 60)).padStart(2, '0');
      const seconds = String(totalSeconds % 60).padStart(2, '0');

      return `${hours}:${minutes}:${seconds}`;
    };

    const dayIndexes = {
      Sun: 0,
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6
    };

    const getTimeZone = (bar) => {
      try {
        zonedParts(bar.dataset.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone);
        return bar.dataset.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (error) {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
    };

    const scheduleState = (bar) => {
      const timeZone = getTimeZone(bar);
      const parts = zonedParts(timeZone);
      const dateKey = `${parts.year}-${parts.month}-${parts.day}`;
      const startDate = bar.dataset.startDate;
      const endDate = bar.dataset.endDate;
      const days = (bar.dataset.visibleDays || '')
        .split(',')
        .filter(Boolean)
        .map((day) => Number(day));
      const currentDay = dayIndexes[parts.weekday];
      const previousDay = currentDay === 0 ? 6 : currentDay - 1;
      const currentMinute = Number(parts.hour) % 24 * 60 + Number(parts.minute);
      const startMinute = minuteValue(bar.dataset.startTime);
      const endMinute = minuteValue(bar.dataset.endTime);
      const endTime = parsedTime(bar.dataset.endTime);

      if (startMinute === null || endMinute === null || !endTime) {
        return {
          active: false,
          target: null
        };
      }

      if (bar.dataset.scheduleEnabled === 'true') {
        if (startDate && dateKey < startDate) {
          return {
            active: false,
            target: null
          };
        }

        if (endDate && dateKey > endDate) {
          return {
            active: false,
            target: null
          };
        }

        if (!days.length) {
          return {
            active: false,
            target: null
          };
        }

        if (startMinute === endMinute) {
          return {
            active: days.includes(currentDay),
            target: zonedDateToInstant(addDays(dateKey, 1), endTime, timeZone)
          };
        }

        if (startMinute < endMinute) {
          return {
            active: days.includes(currentDay) && currentMinute >= startMinute && currentMinute < endMinute,
            target: zonedDateToInstant(dateKey, endTime, timeZone)
          };
        }

        if (days.includes(currentDay) && currentMinute >= startMinute) {
          return {
            active: true,
            target: zonedDateToInstant(addDays(dateKey, 1), endTime, timeZone)
          };
        }

        return {
          active: days.includes(previousDay) && currentMinute < endMinute,
          target: zonedDateToInstant(dateKey, endTime, timeZone)
        };
      }

      if (startMinute > endMinute && currentMinute >= startMinute) {
        return {
          active: true,
          target: zonedDateToInstant(addDays(dateKey, 1), endTime, timeZone)
        };
      }

      if (currentMinute >= endMinute) {
        return {
          active: true,
          target: zonedDateToInstant(addDays(dateKey, 1), endTime, timeZone)
        };
      }

      return {
        active: true,
        target: zonedDateToInstant(dateKey, endTime, timeZone)
      };
    };

    const updateBars = (container = document) => {
      container.querySelectorAll('[data-product-announcement-timer]').forEach((bar) => {
        const state = scheduleState(bar);
        const isDesignMode = window.Shopify && window.Shopify.designMode;
        const isVisible = isDesignMode || state.active;
        const timer = bar.querySelector('[data-product-announcement-timer-clock]');
        const timerValue = bar.querySelector('[data-product-announcement-timer-value]');

        bar.hidden = !isVisible;

        if (!timer || !timerValue || bar.dataset.timerEnabled !== 'true') {
          return;
        }

        if (!state.target) {
          timer.hidden = true;
          return;
        }

        timer.hidden = false;
        timerValue.textContent = formatTimer(state.target.getTime() - Date.now());

        if (state.target.getTime() <= Date.now() && !isDesignMode) {
          bar.hidden = true;
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => updateBars());
    document.addEventListener('shopify:section:load', (event) => updateBars(event.target));

    updateBars();
    window.setInterval(updateBars, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shedule-bar-timer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const minuteValue = (value) => {
      const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(value || '');

      if (!match) {
        return null;
      }

      return Number(match[1]) * 60 + Number(match[2]);
    };

    const parsedTime = (value) => {
      const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(value || '');

      if (!match) {
        return null;
      }

      return {
        hour: Number(match[1]),
        minute: Number(match[2])
      };
    };

    const zonedParts = (timeZone, date = new Date()) => {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone,
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      return formatter.formatToParts(date).reduce((parts, part) => {
        parts[part.type] = part.value;
        return parts;
      }, {});
    };

    const timeZoneOffset = (timeZone, date) => {
      const parts = zonedParts(timeZone, date);
      const asUtc = Date.UTC(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day),
        Number(parts.hour) % 24,
        Number(parts.minute),
        Number(parts.second)
      );

      return asUtc - date.getTime();
    };

    const zonedDateToInstant = (dateKey, time, timeZone) => {
      const dateParts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey || '');

      if (!dateParts || !time) {
        return null;
      }

      const utcGuess = Date.UTC(
        Number(dateParts[1]),
        Number(dateParts[2]) - 1,
        Number(dateParts[3]),
        time.hour,
        time.minute,
        0
      );
      const firstOffset = timeZoneOffset(timeZone, new Date(utcGuess));
      const secondOffset = timeZoneOffset(timeZone, new Date(utcGuess - firstOffset));

      return new Date(utcGuess - secondOffset);
    };

    const addDays = (dateKey, days) => {
      const dateParts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey || '');

      if (!dateParts) {
        return dateKey;
      }

      const date = new Date(Date.UTC(Number(dateParts[1]), Number(dateParts[2]) - 1, Number(dateParts[3]) + days));
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    };

    const formatTimer = (milliseconds) => {
      const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
      const minutes = String(Math.floor(totalSeconds % 3600 / 60)).padStart(2, '0');
      const seconds = String(totalSeconds % 60).padStart(2, '0');

      return `${hours}:${minutes}:${seconds}`;
    };

    const dayIndexes = {
      Sun: 0,
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6
    };

    const getTimeZone = (bar) => {
      try {
        zonedParts(bar.dataset.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone);
        return bar.dataset.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (error) {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
    };

    const scheduleState = (bar) => {
      const timeZone = getTimeZone(bar);
      const parts = zonedParts(timeZone);
      const dateKey = `${parts.year}-${parts.month}-${parts.day}`;
      const startDate = bar.dataset.startDate;
      const endDate = bar.dataset.endDate;
      const days = (bar.dataset.visibleDays || '')
        .split(',')
        .filter(Boolean)
        .map((day) => Number(day));
      const currentDay = dayIndexes[parts.weekday];
      const previousDay = currentDay === 0 ? 6 : currentDay - 1;
      const currentMinute = Number(parts.hour) % 24 * 60 + Number(parts.minute);
      const startMinute = minuteValue(bar.dataset.startTime);
      const endMinute = minuteValue(bar.dataset.endTime);
      const endTime = parsedTime(bar.dataset.endTime);

      if (startMinute === null || endMinute === null || !endTime) {
        return {
          active: false,
          target: null
        };
      }

      if (bar.dataset.scheduleEnabled === 'true') {
        if (startDate && dateKey < startDate) {
          return {
            active: false,
            target: null
          };
        }

        if (endDate && dateKey > endDate) {
          return {
            active: false,
            target: null
          };
        }

        if (!days.length) {
          return {
            active: false,
            target: null
          };
        }

        if (startMinute === endMinute) {
          return {
            active: days.includes(currentDay),
            target: zonedDateToInstant(addDays(dateKey, 1), endTime, timeZone)
          };
        }

        if (startMinute < endMinute) {
          return {
            active: days.includes(currentDay) && currentMinute >= startMinute && currentMinute < endMinute,
            target: zonedDateToInstant(dateKey, endTime, timeZone)
          };
        }

        if (days.includes(currentDay) && currentMinute >= startMinute) {
          return {
            active: true,
            target: zonedDateToInstant(addDays(dateKey, 1), endTime, timeZone)
          };
        }

        return {
          active: days.includes(previousDay) && currentMinute < endMinute,
          target: zonedDateToInstant(dateKey, endTime, timeZone)
        };
      }

      if (startMinute > endMinute && currentMinute >= startMinute) {
        return {
          active: true,
          target: zonedDateToInstant(addDays(dateKey, 1), endTime, timeZone)
        };
      }

      if (currentMinute >= endMinute) {
        return {
          active: true,
          target: zonedDateToInstant(addDays(dateKey, 1), endTime, timeZone)
        };
      }

      return {
        active: true,
        target: zonedDateToInstant(dateKey, endTime, timeZone)
      };
    };

    const updateBars = (container = document) => {
      container.querySelectorAll('[data-shedule-bar-timer]').forEach((bar) => {
        const state = scheduleState(bar);
        const isDesignMode = window.Shopify && window.Shopify.designMode;
        const isVisible = isDesignMode || state.active;
        const timer = bar.querySelector('[data-shedule-bar-timer-clock]');
        const timerValue = bar.querySelector('[data-shedule-bar-timer-value]');

        bar.hidden = !isVisible;

        if (!timer || !timerValue || bar.dataset.timerEnabled !== 'true') {
          return;
        }

        if (!state.target) {
          timer.hidden = true;
          return;
        }

        timer.hidden = false;
        timerValue.textContent = formatTimer(state.target.getTime() - Date.now());

        if (state.target.getTime() <= Date.now() && !isDesignMode) {
          bar.hidden = true;
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => updateBars());
    document.addEventListener('shopify:section:load', (event) => updateBars(event.target));

    updateBars();
    window.setInterval(updateBars, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-quick-order"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class WholesaleQuickOrder extends HTMLElement {
      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('[data-wholesale-row]'));
        this.search = this.querySelector('[data-wholesale-search]');
        this.summary = this.querySelector('[data-wholesale-summary]');
        this.addButton = this.querySelector('[data-wholesale-add]');
        this.message = this.querySelector('[data-wholesale-message]');
        this.status = this.querySelector('[data-wholesale-status]');
        this.bindEvents();
        this.updateAll();
      }

      bindEvents() {
        this.rows.forEach((row) => {
          const variant = row.querySelector('[data-wholesale-variant]');
          const quantity = row.querySelector('[data-wholesale-quantity]');

          if (variant) {
            variant.addEventListener('change', () => this.updateRow(row));
          }

          if (quantity) {
            quantity.addEventListener('input', () => this.updateAll());
          }
        });

        if (this.search) {
          this.search.addEventListener('input', () => this.filterRows());
        }

        if (this.addButton) {
          this.addButton.addEventListener('click', () => this.addSelected());
        }
      }

      selectedOption(row) {
        const field = row.querySelector('[data-wholesale-variant]');

        if (!field) {
          return null;
        }

        if (field.tagName === 'SELECT') {
          return field.selectedOptions[0];
        }

        return field;
      }

      rowPrice(row) {
        const option = this.selectedOption(row);
        return option ? Number(option.dataset.price) || 0 : 0;
      }

      rowQuantity(row) {
        const input = row.querySelector('[data-wholesale-quantity]');
        const quantity = input ? Number(input.value) : 0;
        return Number.isFinite(quantity) && quantity > 0 ? Math.floor(quantity) : 0;
      }

      updateRow(row) {
        const option = this.selectedOption(row);
        const sku = row.querySelector('[data-wholesale-sku]');
        const price = row.querySelector('[data-wholesale-price]');
        const quantity = row.querySelector('[data-wholesale-quantity]');

        if (option) {
          if (sku) {
            sku.textContent = option.dataset.sku || '';
          }

          if (price) {
            price.textContent = this.money(Number(option.dataset.price) || 0);
          }

          if (quantity) {
            quantity.disabled = option.dataset.available !== 'true';
            if (quantity.disabled) {
              quantity.value = 0;
            }
          }
        }

        this.updateAll();
      }

      updateAll() {
        let total = 0;
        let items = 0;

        this.rows.forEach((row) => {
          const quantity = this.rowQuantity(row);
          const lineTotal = quantity * this.rowPrice(row);
          const lineTotalElement = row.querySelector('[data-wholesale-line-total]');

          total += lineTotal;
          items += quantity;

          if (lineTotalElement) {
            lineTotalElement.textContent = this.money(lineTotal);
          }
        });

        if (this.summary) {
          this.summary.textContent = this.money(total);
        }

        if (this.addButton) {
          this.addButton.disabled = items === 0;
        }
      }

      filterRows() {
        const term = this.search.value.trim().toLowerCase();
        let visibleRows = 0;

        this.rows.forEach((row) => {
          const isVisible = !term || row.dataset.searchText.includes(term);
          row.hidden = !isVisible;
          if (isVisible) {
            visibleRows += 1;
          }
        });

        if (this.status) {
          this.status.textContent = `${visibleRows} products shown`;
        }
      }

      selectedItems() {
        return this.rows
          .map((row) => {
            const option = this.selectedOption(row);
            const quantity = this.rowQuantity(row);

            if (!option || quantity < 1 || option.dataset.available !== 'true') {
              return null;
            }

            return {
              id: Number(option.value),
              quantity
            };
          })
          .filter(Boolean);
      }

      async addSelected() {
        const items = this.selectedItems();

        if (!items.length) {
          this.setMessage('Choose at least one quantity before adding to cart.', true);
          return;
        }

        this.addButton.disabled = true;
        this.setMessage('Adding selected items...', false);

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.description || 'Unable to add selected items.');
          }

          this.setMessage('Selected items were added to cart.', false);
          this.clearQuantities();

          if (this.dataset.redirectToCart === 'true') {
            window.location.href = this.dataset.cartUrl;
          }
        } catch (error) {
          this.setMessage(error.message || 'Unable to add selected items.', true);
        } finally {
          this.updateAll();
        }
      }

      clearQuantities() {
        this.rows.forEach((row) => {
          const quantity = row.querySelector('[data-wholesale-quantity]');

          if (quantity) {
            quantity.value = 0;
          }
        });
      }

      setMessage(text, isError) {
        if (!this.message) {
          return;
        }

        this.message.textContent = text;
        this.message.classList.toggle('wholesale-quick-order__message--error', isError);
      }

      money(cents) {
        const amount = Number(cents) / 100;

        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.dataset.currency || 'USD',
            maximumFractionDigits: amount % 1 === 0 ? 0 : 2
          }).format(amount);
        } catch (error) {
          return `$${amount.toFixed(amount % 1 === 0 ? 0 : 2)}`;
        }
      }
    }

    if (!customElements.get('wholesale-quick-order')) {
      customElements.define('wholesale-quick-order', WholesaleQuickOrder);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
